<div class="d-flex" style="position:relative;">
<button class="filter-button btn btn-link toggle d-flex flex-row"  style="align-items: center"
        [type]="btnType" [ngClass]="buttonClass" [disabled]="disabled" (click)="emitButtonClick()" [attr.form]="formId">
  <div *ngIf="iconClass" class="icon-container" style="display: flex">
    <qpoint-loading-spinner style="min-width: 15px" [inline]="true"
                            *ngIf="iconClass && loading"></qpoint-loading-spinner>
    <qpoint-icon style="min-width: 15px; display: flex; justify-content: center" *ngIf="iconClass && !loading" [icon]="iconClass" [iconType]="iconType"
                 [rotate]="iconRotate" [style.color]="iconColor"></qpoint-icon>
  </div>


  <div class="button-content">
    <span *ngIf="label">{{ label }}</span>
    <ng-content></ng-content>
  </div>
  <div *ngIf="badgeValue" class="number-badge">{{ badgeValue < 100 ? badgeValue : '99+' }}</div>
  <div *ngIf="badgeValue && badgeAnimationActive" class="number-badge animation-badge">
    <span>{{ badgeValue < 100 ? badgeValue : '99+' }}</span>
  </div>
</button>
<div class="full-loading-spinner" *ngIf="!iconClass && loading">
  <qpoint-loading-spinner [size]="1"  [inline]="true" *ngIf="!iconClass && loading"></qpoint-loading-spinner>
</div>
</div>
